module.exports = __webpack_public_path__ + "img/gate_2_2.738d32c6.png";